import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=28bb9ddf&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb9ddf",
  null
  
)

export default component.exports